<template>
    <div
        v-gtm:page="'K_TC'"
        v-gtm:type="'Overview'"
        v-gtm:@view
        class="tournamentOverview"
    >
        <FeaturedMatches
            v-bind:featuredMatches="featuredMatches"
            v-bind:isEventsLoaded="tournamentEventsLoaded"
        />
        <div v-if="isShowSMP" class="section">
            <Heading> Boost your odds with SMP </Heading>
            <div
                class="smpCombination"
                style="
            padding: var(--spacers-lg);
            background-color: var(--gray-500);
            border-radius: var(--borderRadius-lg);
"
            >
                SMP Combination content
            </div>
        </div>
        <Standings
            v-for="leagueId in tournamentCenterStandingLeagueIds"
            v-bind:key="leagueId"
            v-bind:leagueId="leagueId"
            v-bind:events="orderedEvents"
        />
        <UpcomingMatches
            v-bind:events="upcomingMatches"
            v-bind:isEventsLoaded="tournamentEventsLoaded"
        />
    </div>
</template>

<script lang="ts" setup>
    import { storeToRefs } from 'pinia';
    import FeaturedMatches from '@/components/tournamentCenter/FeaturedMatches.vue';
    import Standings from '@/components/tournamentCenter/Standings.vue';
    import UpcomingMatches from '@/components/tournamentCenter/UpcomingMatches.vue';
    import { useTournamentCenterOverviewMatches } from '@/core/oddsApi/composable/useTournamentCenterOverviewMatches';
    import { SiteStyle } from '@/interface/enum';
    import { useToggleStore } from '@/store/toggleStore';

    const { tournamentCenterStandingLeagueIds } = storeToRefs(useToggleStore(SiteStyle.Asia));

    const {
        featuredMatches,
        upcomingMatches,
        orderedEvents,
        loaded: tournamentEventsLoaded,
    } = useTournamentCenterOverviewMatches();

    const isShowSMP = false;
</script>

<style lang="scss" scoped>
@import "@/views/tournamentCenter/Overview";
</style>
